import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Window from "../../../../elements/window";
import axios from "axios";
import Slide1 from "./views/slide1";
import Slide2 from "./views/slide2";
import Slide3 from "./views/slide3";
import Slide4 from "./views/slide4";
import Slide5 from "./views/slide5";
import btoa from "btoa";
import "../../../../style.scss";

export default class Week extends Component {
  constructor(props) {
    super(props);

    this.state = {
      params: "",
      fields: {
        sales: { data: [], state: false },
        session: { data: [], state: false },
        brands: { data: [], state: false },
        chains: { data: [], state: false },
        payType: { data: [], state: false },
        revCent: { data: [], state: false },
        group: { data: [], state: false },
        currency: { base: {}, state: false },
        load: false,
      },
    };
  }

  renderTitle = () => (
    <Helmet>
      <title>{this.state.title}</title>
    </Helmet>
  );

  async getCurrency(headers, callback) {
    try {
      const response = await axios.get(
        this.props.chimeraserv.urlGet + "/group",
        { headers }
      );
      let data = [];
      if (Object.keys(response.data).length) {
        data = response.data;
      }
      callback(data);
    } catch {
      callback([]);
    }
  }

  async getGroup(headers, callback) {
    try {
      const response = await axios.get(
        this.props.chimeraserv.urlGet + "/item",
        { headers }
      );
      let data = [];
      if (Object.keys(response.data).length) {
        data = response.data;
      }
      callback(data);
    } catch {
      callback([]);
    }
  }

  async getBrand(headers, callback) {
    try {
      const response = await axios.get(
        this.props.chimeraserv.urlGet + "/brand",
        { headers }
      );
      let data = [];
      if (Object.keys(response.data).length) {
        data = response.data;
      }
      callback(data);
    } catch {
      callback([]);
    }
  }

  async getChain(headers, callback) {
    try {
      const response = await axios.get(
        this.props.chimeraserv.urlGet + "/chain",
        { headers }
      );
      let data = [];
      if (Object.keys(response.data).length) {
        data = response.data;
      }
      callback(data);
    } catch {
      callback([]);
    }
  }

  async getPaytype(headers, callback) {
    try {
      const response = await axios.get(
        this.props.chimeraserv.urlGet + "/paytype",
        { headers }
      );
      let data = [];
      if (Object.keys(response.data).length) {
        data = response.data;
      }
      callback(data);
    } catch {
      callback([]);
    }
  }

  async getRevcent(headers, callback) {
    try {
      const response = await axios.get(
        this.props.chimeraserv.urlGet + "/revcent",
        { headers }
      );
      let data = [];
      if (Object.keys(response.data).length) {
        data = response.data;
      }
      callback(data);
    } catch {
      callback([]);
    }
  }

  encode = () => {
    const today = new Date();

    let lastday = new Date();
    lastday.setHours(23, 59, 59, 59);
    let firstday = new Date(today.setDate(today.getDate() - 6));
    firstday.setHours(0, 0, 0, 0);

    const params = {
      grpKey: { $in: [] },
      braKey: { $in: [] },
      chaKey: { $in: [] },
      date: {
        $gt: parseInt(firstday.getTime() / 1000),
        $lt: parseInt(lastday.getTime() / 1000),
      },
    };

    this.state.fields.chains.data
      .map((data) => ({
        braKey: data.braKey,
        chaKey: data.chaKey,
        grpKey: data.grpKey,
      }))
      .forEach((data) => {
        if (!params.grpKey["$in"].includes(data.grpKey)) {
          params.grpKey["$in"].push(data.grpKey);
        }
        if (!params.chaKey["$in"].includes(data.chaKey)) {
          params.chaKey["$in"].push(data.chaKey);
        }
        if (!params.braKey["$in"].includes(data.braKey)) {
          params.braKey["$in"].push(data.braKey);
        }
      });

    return btoa(JSON.stringify(params));
  };

  async getSales(headers, callback) {
    try {
      const response = await axios.get(
        `${this.props.chimeraserv.urlGet}/sales/set/0/${this.encode()}`,
        { headers }
      );
      let data = [];
      if (Object.keys(response.data).length) {
        data = response.data;
      }
      callback(data);
    } catch {
      callback([]);
    }
  }

  async getSessions(headers, callback) {
    try {
      const response = await axios.get(
        `${this.props.chimeraserv.urlGet}/session/set/0/${this.encode()}`,
        { headers }
      );
      let data = [];
      if (Object.keys(response.data).length) {
        data = response.data;
      }
      callback(data);
    } catch {
      callback([]);
    }
  }

  componentDidMount() {
    if (this.props.user.data) {
      const headers = {
        Authorization: this.props.user.data.usrKey,
        "Content-Type": "application/json",
        Accept: "application/json",
      };

      this.getCurrency(headers, (data) => {
        const array = [];
        const currency = data
          .map((group) => group.baseCurr)
          .filter((currency) => !array.includes(currency));
        this.setState((prevState) => ({
          fields: {
            ...prevState.fields,
            currency: {
              base: currency[0] ? currency[0]?.toUpperCase() : "QAR",
              state: true,
            },
          },
        }));
      });

      this.getBrand(headers, (data) => {
        this.setState((prevState) => ({
          fields: {
            ...prevState.fields,
            brands: {
              data: data,
              state: true,
            },
          },
        }));
      });

      this.getChain(headers, (data) => {
        this.setState((prevState) => ({
          fields: {
            ...prevState.fields,
            chains: {
              data: data,
              state: true,
            },
          },
        }));
      });

      this.getRevcent(headers, (data) => {
        this.setState((prevState) => ({
          fields: {
            ...prevState.fields,
            revCent: {
              data: data,
              state: true,
            },
          },
        }));
      });

      this.getPaytype(headers, (data) => {
        this.setState((prevState) => ({
          fields: {
            ...prevState.fields,
            payType: {
              data: data,
              state: true,
            },
          },
        }));
      });

      this.getGroup(headers, (data) => {
        this.setState((prevState) => ({
          fields: {
            ...prevState.fields,
            group: {
              data: data,
              state: true,
            },
          },
        }));
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.fields.chains.state !== this.state.fields.chains.state) {
      const headers = {
        Authorization: this.props.user.data.usrKey,
        "Content-Type": "application/json",
        Accept: "application/json",
      };

      this.getSales(headers, (data) => {
        this.setState((prevState) => ({
          fields: {
            ...prevState.fields,
            sales: {
              data: data,
              state: true,
            },
          },
        }));
      });

      this.getSessions(headers, (data) => {
        this.setState((prevState) => ({
          fields: {
            ...prevState.fields,
            session: {
              data: data,
              state: true,
            },
          },
        }));
      });
    }
  }

  blockFilter() {
    if (
      !this.state.fields.load &&
      this.state.fields.session.state &&
      this.state.fields.payType.state &&
      this.state.fields.revCent.state &&
      this.state.fields.chains.state &&
      this.state.fields.group.state &&
      this.state.fields.brands.state &&
      this.state.fields.sales.state &&
      this.state.fields.currency.state
    ) {
      this.setState((prevState) => ({
        fields: {
          ...prevState.fields,
          load: true,
        },
      }));
    }
  }

  render() {
    return (
      <section>
        <div className={["report"]}>
          {this.blockFilter()}
          <Window
            user={this.props.user}
            chimeraserv={this.props.chimeraserv}
            title={"Weekly Sales"}
          >
            <Slide1
              {...this.state}
              user={this.props.user.data}
              data={this.state.fields.load ? this.state.fields : null}
            />
          </Window>
          <div className={["contentContainer"]}>
            <div className={["contentRow"]} style={{ width: "49.55%" }}>
              <Window
                user={this.props.user}
                chimeraserv={this.props.chimeraserv}
                title={"Revenue Center"}
                horizontal
              >
                <Slide2
                  {...this.state}
                  data={this.state.fields.load ? this.state.fields : null}
                />
              </Window>
            </div>
            <div className={["contentRow"]} style={{ width: "49.55%" }}>
              <Window
                user={this.props.user}
                chimeraserv={this.props.chimeraserv}
                title={"Payment Type"}
                horizontal
              >
                <Slide3
                  {...this.state}
                  data={this.state.fields.load ? this.state.fields : null}
                />
              </Window>
            </div>
          </div>
          <div className={["contentContainer"]}>
            <div className={["contentRow"]} style={{ width: "49.55%" }}>
              <Window
                user={this.props.user}
                chimeraserv={this.props.chimeraserv}
                title={"Group by Items"}
                horizontal
              >
                <Slide4
                  {...this.state}
                  data={this.state.fields.load ? this.state.fields : null}
                />
              </Window>
            </div>
            <div className={["contentRow"]} style={{ width: "49.55%" }}>
              <Window
                user={this.props.user}
                chimeraserv={this.props.chimeraserv}
                title={"Weekly Sessions"}
                horizontal
              >
                <Slide5
                  {...this.state}
                  data={this.state.fields.load ? this.state.fields : null}
                />
              </Window>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
